<template>
  <div>
    <div class="x-banner">
      <!-- banner -->
      <BANNER></BANNER>
      <!-- 二级导航 -->
      <NAVIGATION
        :data="navigationData"
        :currentPath="currentPath"
      ></NAVIGATION>
    </div>
    <div class="container-width location">
      当前位置:<router-link to="/">首页</router-link> >
      <router-link to="/sjwh">盛京文化</router-link> >
      <router-link to="/sjwh/yuange">院标/办院理念/院训/院歌</router-link>
    </div>

    <div class="container-width x-article">
      <!-- <div class="title">院标/办院理念/院训/院歌</div> -->
      <div class="pt50"></div>
      <div class="l-content">
        <div class="list">
          <div>院标</div>
        </div>
        <div class="description" v-html="hospitalTraining.description"></div>
      </div>
      <div class="l-content">
        <div class="list">
          <div>办院理念</div>
        </div>
        <div class="description" v-html="concepts.description"></div>
      </div>
      <div class="l-content">
        <div class="list">
          <div>院训</div>
        </div>
        <div class="description" v-html="academy.description"></div>
      </div>
      <div class="l-content">
        <div class="list">
          <div>院歌</div>
        </div>
        <div class="yuange">
          <div class="song">
            <img :src="themeSong.img" />
          </div>
          <div class="video">
            <!--            <video-->
            <!--              controls="controls"-->
            <!--              id="videoElement"-->
            <!--              style="width: 100%"-->
            <!--            ></video>-->

            <hls-video
              :videoUrl="themeSong.video"
              class="videoBox"
              :videoType="videoType"
              style="height: 370px; width: 100%"
              v-if="renderComponent && videoType == 'mp4'"
            ></hls-video>
            <hls-video
              :videoUrl="themeSong.video"
              class="videoBox"
              :videoType="videoType"
              style="height: 370px; width: 100%"
              v-if="renderComponent && videoType == 'flv'"
            ></hls-video>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import service from "../../service/sjwh";
import BANNER from "../../components/banner/sjwh";
import config from "../../config/dev";
// import flvjs from "flv.js";
import HlsVideo from "@/components/HlsVideo";
export default {
  name: "YUANGE",
  data() {
    return {
      navigationData: [
        {
          name: "百年历史",
          path: "/sjwh",
          width: "50%",
        },
        {
          name: "院标/办院理念/院训/院歌",
          path: "/sjwh/yuange",
          width: "50%",
        },
        // {
        //   name: "盛京医讯",
        //   path: "/sjwh/zhoukan",
        //   width: "33%",
        // },
        // {
        //   name: "盛京TV",
        //   path: "/sjwh/tv",
        // },
        {
          name: "盛京映像",
          path: "/sjwh/yingxiang",
        },
        // {
        //   name: "盛京医院的故事",
        //   path: "/sjwh/gushi",
        // },
      ],
      currentPath: "/sjwh/yuange",
      themeSong: {}, // 院歌
      hospitalTraining: {}, // 院标
      academy: {}, // 院训
      concepts: {}, // 办院理念
      renderComponent: false,
      videoType: "flv",
    };
  },
  components: { BANNER, HlsVideo },
  computed: {},
  created() {
    this.init();
  },
  beforeMount() {},
  methods: {
    init() {
      service.getSongList({}, (res) => {
        console.log("res", res);
        res.content.map((item) => {
          if (item.title == "院歌") {
            item.img = item.img
              ? config.url +
                "/file/downloadFile/" +
                item.img +
                "?isDownload=true"
              : "";
            item.video = item.video
              ? config.url + "/file/getVideo?id=" + item.video
              : "";

            this.themeSong = { ...item };
            this.videoType = item.videotype;
            this.renderComponent = true;
          } else if (item.title == "院标") {
            item.img = item.img
              ? config.url +
                "/file/downloadFile/" +
                item.img +
                "?isDownload=true"
              : "";
            if (window.screen.width < 720) {
              item.description = item.description.replace(
                /\<img/gi,
                '<img style="max-width: 50%;margin: 0 auto;display: block;"'
              );
            }

            this.hospitalTraining = { ...item };
          } else if (item.title == "院训") {
            item.img = item.img = item.img
              ? config.url +
                "/file/downloadFile/" +
                item.img +
                "?isDownload=true"
              : "";
            this.academy = { ...item };
          } else if (item.title == "办院理念") {
            item.img = item.img = item.img
              ? config.url +
                "/file/downloadFile/" +
                item.img +
                "?isDownload=true"
              : "";
            this.concepts = { ...item };
          }
        });
      });
    },
    // 视频初始化
    videoInit(url) {
      if (flvjs.isSupported()) {
        var videoElement = document.getElementById("videoElement");
        this.flvPlayer = flvjs.createPlayer(
          {
            type: "flv",
            isLive: true,
            hasAudio: true, // 是否有音频
            hasVideo: true, // 是否有视频
            url: url,
            enableStashBuffer: true, //是否启用缓存区
          },
          {
            enableWorker: false, //不启用分离线程
            enableStashBuffer: false, //关闭IO隐藏缓冲区
            autoCleanupSourceBuffer: true, //自动清除缓存
            lazyLoad: false,
          }
        );
        this.flvPlayer.attachMediaElement(videoElement);
        this.flvPlayer.load();
        this.flvPlayer.play();
      }
    },
  },
  mounted() {},
  watch: {},
  destroyed() {
    // if (this.flvPlayer) {
    //   this.flvPlayer.pause();
    //   this.flvPlayer.unload();
    //   this.flvPlayer.detachMediaElement();
    //   this.flvPlayer.destroy();
    //   this.flvPlayer = null;
    // }
  },
};
</script>

<style lang="scss" scoped>
.pt50 {
  padding-top: 50px;
}
.x-article {
  -webkit-transition: all 0.5s ease 0s;
  -moz-transition: all 0.5s ease 0s;
  transition: all 0.5s ease 0s;
  box-shadow: 4px 4px #ececec;
  margin-bottom: 50px;
  border: 1px solid #ebebeb;
  border-top: none;
  box-sizing: border-box;

  .title {
    padding-top: 30px;
    padding-bottom: 30px;
    font-weight: bold;
    text-align: center;
    border-bottom: 1px solid #ebebeb;
    font-size: 1.4rem;
  }
  .l-content {
    // padding: 50px 50px 50px 50px;
    margin: 0 50px 0 50px;
    .list {
      margin-bottom: 30px;
      font-size: 1.2rem;
      background: #00479d;
      color: #fff;
      cursor: pointer;
      height: 60px;
      line-height: 60px;
      padding-left: 10px;
    }
    .description {
      font-size: 1.2rem;
      line-height: 40px;
    }
    .yuange {
      font-size: 1.2rem;
      line-height: 40px;
      display: -webkit-flex;
      display: flex;
      -webkit-box-pack: justify;
      -webkit-justify-content: space-between;
      -ms-flex-pack: justify;
      justify-content: space-between;
      padding-top: 15px;
      -webkit-box-align: center;
      align-items: center;
      .song {
        max-width: 98%;
        max-height: 400px;
        overflow: hidden;
        img {
          max-width: 100%;
          max-height: 400px;
        }
      }
      .video {
        width: 49%;
      }
    }
  }
}
@media only screen and (max-width: 728px) {
  .pt50 {
    padding-top: 30px;
  }
  .x-article {
    .l-content {
      padding: 0 5px 5px 5px;
      margin: 0 15px 0 15px;
      .list {
        font-size: 0.95rem;
      }
      .description {
        font-size: 1rem;
        line-height: 1.8rem;
      }
      .yuange {
        flex-direction: column;
        .song {
          max-width: 98%;
          max-height: 400px;
          overflow: hidden;
          img {
            max-width: 100%;
            max-height: 400px;
          }
        }
        .video {
          width: 100%;
        }
      }
    }
  }
}
</style>
